<script setup lang="ts">
import BaseInput from '@/common/components/molecules/input/BaseInput.vue';
import MenuSearchContent from './MenuSearchContent.vue';
import MenuSearchFooter from './MenuSearchFooter.vue';
import { setup } from './menuSearch.setup';

const { t, isShow, searchWord, contentRef, inputRef, closeMenuSearch, handleSearchInput } = setup();
</script>

<template>
  <ev-window
    v-model:visible="isShow"
    window-class="menu-search-window"
    width="640px"
    close-on-click-modal
  >
    <section class="menu-search-window__search">
      <base-input
        ref="inputRef"
        v-model:value="searchWord"
        :placeholder="t('WORD.SEARCH')"
        size="large"
        prefix-inner-icon="ev-icon-search2"
        @on-change="handleSearchInput"
      />
    </section>
    <section class="menu-search-window__content">
      <menu-search-content ref="contentRef" />
      <menu-search-footer @close="closeMenuSearch" />
    </section>
  </ev-window>
</template>

<style lang="scss">
.menu-search-window {
  --menu-search-window-height: auto;
  --menu-search-window-top: calc((100vh - 652px) / 2);

  top: var(--menu-search-window-top) !important;
  height: var(--menu-search-window-height) !important;
  padding: 8px;
  border-radius: 6px !important;
  background: var(--color-gray-09-01) !important;

  .ev-window-top-right-icon {
    display: none;
  }

  .ev-window-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
    width: 100%;
    padding: 0 !important;
  }

  &__search {
    width: 100%;
    min-height: 36px;

    .base-input {
      input {
        border: none;
      }

      input::placeholder {
        background-color: transparent;
        color: var(--color-gray-04-08);
      }

      &__icon {
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: var(--color-gray-03-09);
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 8px 0;
    overflow-y: auto;
    border: 1px solid var(--color-gray-05-03);
    border-radius: 6px;
    background: var(--color-gray-06-00);
  }

  &__content-panel {
    height: 100%;
    padding: 0 12px;
  }

  &__divider {
    width: 100%;
    height: 1px;
    background: var(--color-gray-05-03);
  }
}
</style>
